import { Attr, BelongsTo, HasMany, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

import type Organisation from "./Organisation";
import type SourceRecord from "./SourceRecord";

@Model()
class SourceRestriction extends ApplicationRecord {
  static jsonapiType = "source_restrictions";

  @Attr({ persist: false }) archivedAt: string;

  @Attr({ persist: false }) createdAt: string;

  @HasMany() organisations: Organisation[];

  @BelongsTo() source: SourceRecord;

  @Attr() sourceId: string;

  @Attr() sourceType: string;

  @Attr({ persist: false }) updatedAt: string;
}

export default SourceRestriction;
